import { mapGetters } from "vuex";
import DeviceDetectionMixin from "@/mixins/DeviceDetectionMixin";

export default {
  mixins:[DeviceDetectionMixin],
  methods: {
    canUserShow(screen){
      let user_access_screen_permission = {};
      user_access_screen_permission = this.screen_accessible.find(item => item.url == '/'+screen);
      return (user_access_screen_permission !== undefined);
    },
    canUserEdit() {
      let url = '';
      let user_access_screen_permission = {};
      
      if (this.$route?.path.startsWith('/projects')) {
        // 作業指示の一覧で else 側の分岐の meta() が取れないので分岐
        url = '/projects';
        user_access_screen_permission = this.screen_accessible.find(item => item.url == url);
      } else if (this.$route?.path.startsWith('/notifications')) {
        url = '/notifications';
        user_access_screen_permission = this.screen_accessible.find(item => item.url == url);      
      } else {
        url = this.$route?.meta()?.url;
        user_access_screen_permission = this.screen_accessible.find(item => item.url == url);
      }

      // console.log('permission: url=' + url + ', user_access_screen_permission=' + JSON.stringify(user_access_screen_permission));

      // 1:登録 or 3:管理 なら更新可能
      return user_access_screen_permission?.zz_update_permission_id === this.$constant.ZzUpdatePermissions.registration
        || user_access_screen_permission?.zz_update_permission_id === this.$constant.ZzUpdatePermissions.admin;
    },
    canUserDelete() {
      let url = this.$route?.meta()?.url;
      let user_access_screen_permission = this.screen_accessible.find(item => item.url == url);

      // 3:管理 のみ削除可能
      return user_access_screen_permission?.zz_update_permission_id === this.$constant.ZzUpdatePermissions.admin;
    },
    isUserHasScreenAccess (screens = []) {
      screens.forEach(screen => {
        let user_access_screen_permission = this.screen_accessible.find(item => item.id == screen?.id);
          if (user_access_screen_permission) {
            return true;
          }
      });

      return false
    },
    getRootScreenUrl() {
      let screenAccess = this.screen_accessible;

      const defaultUrl = this.detectMobileDevice() ? "/factories" : "/";
      const foundScreen = screenAccess.find(screen => screen.url === defaultUrl);
      if (foundScreen) {
        return defaultUrl;
      }
      return screenAccess[0]?.url ?? '/';
    },
  },
  computed: {
    ...mapGetters("permissions", ["screen_accessible"]),
  }
};
